import moment from "moment";
import { formatMoney } from "../utils/formatMoney";

export function templateLoanData(data) {
  // const name = [data?.applierFirstName, data?.applierLastName]
  //   ?.filter((nm) => Boolean(nm))
  //   .join(" ");

  return [
    {
      elements: [
        {
          type: "text",
          value: moment(data?.createdAt).format("hh:mm A"),
        },
        {
          type: "title",
          value: moment(data?.createdAt).format("DD/MM/YYYY"),
        },
      ],
      value: moment(data?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: `Reference`,
        },
        {
          type: "text",
          value: data?.bookingReference || "---",
        },
        {
          type: "title",
          value: `Destination`,
        },
        {
          type: "text",
          value: data?.destination || "---",
        },
      ],
      value: "",
      width: "md:w-[20%]",
    },
    {
      elements: [
        {
          type: "title",
          value: `Agency`,
        },
        {
          type: "text",
          value: data?.agent?.agencyName || data?.agencyName || "---",
        },
        {
          type: "title",
          value: `Agent`,
        },
        {
          type: "text",
          value: data?.agent?.agentName || data?.agent?.agentName || "---",
        },
      ],
      value: "",
      width: "md:w-[20%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Installments",
        },
        {
          type: "text",
          value: data?.planDuration ? String(data?.planDuration) : "0",
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Amount Disbursed",
        },
        {
          type: "text",
          value: data?.loanAmount ? formatMoney(data?.loanAmount) : "---",
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Service Fee",
        },
        {
          type: "text",
          value: data?.serviceFeePerMonth
            ? formatMoney(data?.serviceFeePerMonth)
            : "---",
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Approval Status",
        },
        {
          type: "status",
          value: data?.status,
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Amount Paid",
        },
        {
          type: "text",
          value: data?.totalPaid ? formatMoney(data?.totalPaid) : "---",
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },

    {
      elements: [
        {
          type: "title",
          value: "Repayment Status",
        },
        {
          type: "status",
          value: data?.repaymentStatus,
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
  ];
}
